import { inject } from '@angular/core';
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { SessionService } from '../services/session.service';
import { ServicesService } from '../services/services.service';
import { CustomNavigationService } from '../services/custom-navigation.service';
import { Observable } from 'rxjs';
import { GroupType } from '../enums/enums';

export function hcpGuard(): CanActivateFn {
  return (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree => {
    const authService: SessionService = inject(SessionService);
    const services: ServicesService = inject(ServicesService);
    const navigationService: CustomNavigationService = inject(
      CustomNavigationService
    );

    if (authService.isLoggedIn() && authService.hasRole(GroupType.Hcp)) {
      let currentRole = authService.getCurrentRole();
      let groupType = GroupType;
      let role;
      if (currentRole.group.type !== groupType.Hcp) {
        if (authService.hasRole(GroupType.Hcp)) {
          role = authService.getRole(GroupType.Hcp);
          currentRole = role;
          services.roleService.changeRole(role, state.url);
        }
      }
      return true;
    } else {
      authService.clearStorage();
      // Notifier danger
      return false;
    }
  };
}
